const baseUrlDevlopment = "https://localhost:53842/api/";
const baseUrlLive = "https://o3rg84uzj2.execute-api.ap-south-1.amazonaws.com/Prod/api/";

const GetBaseUrl = () => {
    //return import.meta.env.PROD ? baseUrlLive : baseUrlDevlopment;
    return baseUrlLive ;
}

export const DomainService = {
    GetBaseUrl
}
